import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeStyles: React.FC = () => {
  const { theme } = useTheme();

  return (
    <style>
      {`
        :root {
          --primary: ${theme.primary};
          --primary-dark: ${theme.primaryDark};
          --secondary: ${theme.secondary};
          --background: ${theme.background};
          --background-light: ${theme.backgroundLight};
          --text-primary: ${theme.textPrimary};
          --text-secondary: ${theme.textSecondary};
          --text-light: ${theme.textLight};
          --shadow: ${theme.shadow};
          --border: ${theme.border};
          --hover: ${theme.hover};
          --accent: ${theme.accent};
          --border-radius: 8px;
          --spacing: 20px;
        }
      `}
    </style>
  );
};

export default ThemeStyles;